import { render, staticRenderFns } from "./related-data.component.vue?vue&type=template&id=300af380&scoped=true"
import script from "./related-data.component.vue?vue&type=script&lang=ts"
export * from "./related-data.component.vue?vue&type=script&lang=ts"
import style0 from "./related-data.component.vue?vue&type=style&index=0&id=300af380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300af380",
  null
  
)

export default component.exports